import { AllowedDeliveryChannel, EmailSenderOption, SenderOptionBase, SMSSenderOption } from "..";

export class SenderOption {
  id: number;
  channelType: AllowedDeliveryChannel;
  value: SenderOptionBase | EmailSenderOption | SMSSenderOption | string;
  isActive: boolean;
  isApproved: boolean;
}
